import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, map, Observable } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { BulevartService } from '../bulevart.service';
import { GalerieBulevart, UpdateImageBulevart } from '../bulevart.interface';
import { Generic } from 'src/app/interfaces/generic.interface';
import { CategoriesService } from '../../bulevart-settings/categories/categories.service';
import { SubcategoriesService } from '../../bulevart-settings/subcategories/subcategories.service';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';
import { TertiaryCategoriesService } from '../../bulevart-settings/tertiary-categories/tertiary-categories.service';

@Component({
    selector: 'app-edit-bulevart-image',
    templateUrl: './edit-bulevart-image.component.html',
    styleUrls: ['./edit-bulevart-image.component.scss']
})
export class EditBulevartImageComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    helper = helper;

    isLoading = false;

    categorii$!: Observable<Generic[]>;
    subcategorii$!: Observable<Generic[]>;
    categoriiTertiare$!: Observable<Generic[]>;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        id_category: new FormControl(this.data.id_category, [Validators.required, notDefaultValidator('-1')]),
        id_subcategory: new FormControl(this.data.id_subcategory, [Validators.required, notDefaultValidator('-1')]),
        id_tertiary_category: new FormControl(this.data.id_tertiary_category, []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: GalerieBulevart,
        private dialogRef: MatDialogRef<EditBulevartImageComponent>,
        private bulevartService: BulevartService,
        private categoriesService: CategoriesService,
        private subcategoriesService: SubcategoriesService,
        private tertiaryCategoriesService: TertiaryCategoriesService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() {
        this.loadCategoriesActive();
        this.loadSubcategorii(this.data.id_category);
        this.loadCategoriiTertiare(this.data.id_subcategory);
    }

    loadCategoriesActive() {
        this.isLoading = true;
        this.categorii$ = this.categoriesService
            .getListActive()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]),
                finalize(() => (this.isLoading = false))
            );
    }

    onCategorieChange(categorieId: number): void {
        if (categorieId > -1) {
            this.loadSubcategorii(categorieId);
        } else {
            this.subcategorii$ = new Observable<Generic[]>((observer) => {
                observer.next([{ name: '--Alegeți--', id: -1 }]);
                observer.complete();
            });
        }

        this.categoriiTertiare$ = new Observable<Generic[]>((observer) => {
            observer.next([{ name: '--Alegeți--', id: -1 }]);
            observer.complete();
        });

        this.form.get('id_subcategory')?.setValue(-1);
        this.form.get('id_tertiary_category')?.setValue(-1);
    }

    loadSubcategorii(categorieId?: number) {
        this.isLoading = true;
        let subcategoriiObservable$ = categorieId
            ? this.subcategoriesService.getListByCategory(categorieId)
            : this.subcategoriesService.getListActive();

        this.subcategorii$ = subcategoriiObservable$.pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => {
                this.isLoading = false;
            })
        );
    }

    onSubcategorieChange(subcategorieId: number): void {
        if (subcategorieId > -1) {
            this.loadCategoriiTertiare(subcategorieId);
        } else {
            this.categoriiTertiare$ = new Observable<Generic[]>((observer) => {
                observer.next([{ name: '--Alegeți--', id: -1 }]);
                observer.complete();
            });
        }

        this.form.get('id_tertiary_category')?.setValue(-1);
    }

    loadCategoriiTertiare(subcategorieId?: number) {
        this.isLoading = true;
        let tertiareObservable$ = subcategorieId
            ? this.tertiaryCategoriesService.getListBySubcategory(subcategorieId)
            : this.tertiaryCategoriesService.getListActive();

        this.categoriiTertiare$ = tertiareObservable$.pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => {
                this.isLoading = false;
            })
        );
    }

    submitForm() {
        this.isLoading = true;

        const {
            id_category,
            id_subcategory,
            id_tertiary_category,
        } = this.form.value;

        const payload: UpdateImageBulevart = {
            id: this.data.id,
            id_category,
            id_subcategory,
            id_tertiary_category
        }

        this.bulevartService
            .updateImage(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}